import { IconButton, Modal, Stack, Typography } from "@mui/material";
import { PrescriptionWithMedication } from "src/api/types";
import { desktopSx } from "src/utils/styles/modalStyles";
import DataTable from "../DataTable";
import { useColumns } from "./useColumns";
import { useCallback, useMemo, useState } from "react";
import { Close } from "@mui/icons-material";
import EditPrescriptionMedication from "./components/EditPrescriptionMedication";

interface Props {
  open: boolean;
  onClose: () => void;
  prescriptions: PrescriptionWithMedication[];
}

const PendingPrescriptions = ({ open, prescriptions, onClose }: Props) => {
  const height = useMemo(() => window.innerHeight - 104 - 64 - 34, []);
  const [editItem, setEditItem] = useState<{
    id: number;
    productId: number;
    patientId: number;
    count?: number;
    medication_id?: number;
  } | null>(null);
  const columns = useColumns(setEditItem);

  const handleReturn = useCallback(() => {
    setEditItem(null);
  }, [setEditItem]);

  const handleClose = useCallback(() => {
    handleReturn();
    onClose();
  }, [handleReturn, onClose]);

  return (
    <Modal open={open}>
      <Stack sx={desktopSx} width={"90vw"} height={"90vh"}>
        <Stack gap={5}>
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography variant="h4" fontWeight={600}>
              Pending Prescriptions
            </Typography>
            <IconButton onClick={handleClose} sx={{ p: 0 }}>
              <Close fontSize="large" />
            </IconButton>
          </Stack>
          {editItem != null ? (
            <EditPrescriptionMedication
              item={editItem}
              onReturn={handleReturn}
            />
          ) : (
            <DataTable
              columns={columns}
              data={prescriptions}
              primaryKey="id"
              height={height}
            />
          )}
        </Stack>
      </Stack>
    </Modal>
  );
};

export default PendingPrescriptions;
